import { render, staticRenderFns } from "./HeaderCustom.vue?vue&type=template&id=3be6c6c7&scoped=true"
import script from "./HeaderCustom.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderCustom.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderCustom.vue?vue&type=style&index=0&id=3be6c6c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be6c6c7",
  null
  
)

export default component.exports